import { memo } from 'react';
import { Divider, IconButton, Typography } from '@trackman/web-shared-components';
import { ReactComponent as AdjustmentsIcon } from 'svg/Adjustments.svg';
import { ReactComponent as MinusCircleIcon } from 'svg/MinusCircle.svg';
import { ReactComponent as PlusCircleIcon } from 'svg/PlusCircle.svg';
import { ChartType } from 'types/CodegenReportTypes';

type Props = {
  chartId: ChartType;
  onEditClick?: (id: ChartType) => void;
  onToggleVisibility: (id: ChartType) => void;
  chartLabel: string;
  subtitle: string;
  isHidden: boolean;
};

const ChartSidebarSummary = memo(({ chartId, onEditClick, onToggleVisibility, chartLabel, subtitle, isHidden }: Props) => {
  const handleEdit = () => onEditClick?.(chartId);
  const handleToggle = () => onToggleVisibility(chartId);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 0' }}>
        <div>
          <Typography variant='body' component='div'>
            {chartLabel}
          </Typography>
          <Typography variant='label' component='div' color='#A0A0A0'>
            {subtitle}
          </Typography>
        </div>
        <div style={{ minWidth: 'fit-content' }}>
          {onEditClick && !isHidden && (
            <IconButton intent='tertiary' onClick={handleEdit} icon={() => <AdjustmentsIcon />} className='ChartWrapper-edit-button' />
          )}
          <IconButton
            intent='tertiary'
            onClick={handleToggle}
            icon={() => (isHidden ? <PlusCircleIcon /> : <MinusCircleIcon />)}
            className='ChartWrapper-edit-button'
          />
        </div>
      </div>
      <Divider />
    </>
  );
});

export default ChartSidebarSummary;
